import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "../components/PageHero";
import { FeatureList, CTASection } from "../components/Sections";
import { ComplianceBanner } from "../components/ComplianceBanner";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../data/config";

export default function RiskOptions() {
  const { t } = useTranslation();
  return (
    <>
      <PageHero
        overline={t("risk.overline")}
        title={<>{t("risk.titleA")} <span className="text-gradient-gold">{t("risk.titleAccent")}</span></>}
        subtitle={t("risk.subtitle")}
        image={IMAGES.riskOps}
        accent="gold"
        testId="risk-options-hero"
      />
      <FeatureList overline={t("risk.featOverline")} title={t("risk.featTitle")} accent="gold" items={t("risk.features", { returnObjects: true })} />
      <section className="pb-8">
        <div className="container-x"><Reveal><ComplianceBanner text={t("risk.banner")} /></Reveal></div>
      </section>
      <CTASection title={t("risk.ctaTitle")} subtitle={t("risk.ctaSub")} ctaLabel={t("common.getQuote")} ctaTo="/quote?plan=black" variant="gold" testId="risk-options-cta" />
    </>
  );
}
